import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Logo } from './Logo';
import { CheckCircle2 } from 'lucide-react';

export const SuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const intakeId = searchParams.get('intake_id');
  const isFree = searchParams.get('free') === 'true';

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: 'var(--color-bg)' }} data-testid="success-page">
      <div className="card max-w-2xl w-full p-10 text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ backgroundColor: 'var(--color-navy)' }}>
          <CheckCircle2 className="w-12 h-12 text-white" />
        </div>

        <h1 className="mb-4" style={{ color: 'var(--color-navy)' }} data-testid="success-title">
          {isFree ? 'Submission Successful!' : 'Payment Successful!'}
        </h1>

        <p className="text-lg mb-6" style={{ color: 'var(--color-muted)' }}>
          {isFree 
            ? 'Thank you for your submission. Your discount code has been applied successfully.'
            : 'Thank you for your order. Your payment has been processed successfully.'}
        </p>

        <div className="rounded-lg p-6 mb-8 text-left" style={{ backgroundColor: 'var(--color-bg)', border: '1px solid var(--color-border)' }}>
          <h2 className="text-lg font-semibold mb-4" style={{ color: 'var(--color-navy)' }}>
            What happens next?
          </h2>
          <ul className="space-y-3" style={{ color: 'var(--color-muted)' }}>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--color-navy)' }} />
              <span>You'll receive a confirmation email shortly</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--color-navy)' }} />
              <span>Our team will review your uploaded information and project details</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--color-navy)' }} />
              <span>We'll prepare your professional Schedule of Works</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--color-navy)' }} />
              <span>You'll receive your completed documents within the agreed turnaround time</span>
            </li>
            <li className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: 'var(--color-navy)' }} />
              <span>If we need any clarifications, we'll contact you directly</span>
            </li>
          </ul>
        </div>

        {intakeId && (
          <p className="text-sm mb-6" style={{ color: 'var(--color-muted)' }}>
            Reference ID: <span className="font-mono">{intakeId}</span>
          </p>
        )}

        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="btn-primary w-full py-4"
            data-testid="success-home-btn"
          >
            Return to Home
          </button>
          <p className="text-sm" style={{ color: 'var(--color-muted)' }}>
            You will be automatically redirected in 10 seconds
          </p>
        </div>

        <div className="mt-8 pt-8" style={{ borderTop: '1px solid var(--color-border)' }}>
          <p style={{ color: 'var(--color-muted)' }}>
            Questions? Contact us at{' '}
            <a href="mailto:team@schedulesofwork.com" className="font-medium hover:underline" style={{ color: 'var(--color-navy)' }}>
              team@schedulesofwork.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
